import { Button } from '@shared/components/common/Button';
import { useNavigate } from 'react-router-dom';
import SuccessIcon from '@shared/assets/images/success_icon.svg';
import RegistrationFrame from '../RegistrationFrame';

export default function RegistrationStepThree() {
    // hook

    const navigate = useNavigate();

    return (

        <RegistrationFrame currentStep={3}>
            <div className='flex flex-col gap-8 w-full'>
                <div className='bg-background-1 flex flex-col items-center md:gap-6 gap-4 rounded text-lg font-medium w-full'>
                    <img className='h-[100px]' src={SuccessIcon} alt='email-icon' />
                    <div className='space-y-3 text-center'>
                        <p>ご登録いただきありがとうございます。</p>
                        <p>登録いただいたメールアドレスに完了通知を送信しました。</p>
                    </div>

                </div>
                <div className='w-full flex justify-center'>
                    <Button onClick={() => navigate('/')} variant='default' className='rounded-[10px] w-full h-14'>トップページへ</Button>
                </div>

            </div>
        </RegistrationFrame>

    );
}
